import { Navigate } from 'react-router-dom';
export default function Curriculo() {
  return <Navigate to="/perfil?tab=curriculo" replace />;
}
